import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import { getRandomNumber } from 'utils/utils';
import geruLogo from 'assets/img/partners/geru@2x.png';
import creditasLogo from 'assets/img/partners/creditas@2x.png';
import rapidooLogo from 'assets/img/partners/rapidoo@2x.png';
import bCrediLogo from 'assets/img/partners/bcredi@2x.png';
import tickIcon from 'assets/svg/tick.svg';
import crossIcon from 'assets/svg/cross.svg';
import chevronIcon from 'assets/svg/chevron-right.svg';

export enum PartnersListMode {
    LINE = 0,
    COLUNM = 1,
}

export const GeruLogo = () => (
    <img src={geruLogo} alt="Geru" />
);

export const CreditasLogo = () => (
    <img src={creditasLogo} alt="Creditas" />
);

export const RapidooLogo = () => (
    <img src={rapidooLogo} alt="Rapidoo" />
);

export const BCrediLogo = () => (
    <img src={bCrediLogo} alt="BCredi" />
);

export const TickIcon = () => (
    <img src={tickIcon} alt="Com garantia" />
);

export const CrossIcon = () => (
    <img src={crossIcon} alt="Sem garantia" />
);

export const WithSlider: React.FC<{ showArrows?: boolean, size: number }> = ({ showArrows = true, size, children }) => {
    const _slide = useRef<Slider>();

    const config = getSlideConfig(
        () => _slide.current.slickPrev(),
        () => _slide.current.slickNext(),
        showArrows,
        size,
    );

    return (
        <Slider ref={_slide} className="partners-list" {...config}>
            { children }
        </Slider>
    );
}

function getSlideConfig(onNext: any, onPrev: any, showArrows: boolean, size: number): Settings {
    const initialSlide = getRandomNumber(0, size - 1);

    return {
        initialSlide,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        responsive: [{
            breakpoint: 579,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        }],
        appendDots: () => {
            const showOnMobileClassName = !showArrows ? 'd-none d-sm-block' : '';

            return (
                <div>
                    <button className={['prev', showOnMobileClassName].join(' ')} onClick={onNext}>
                        <img src={chevronIcon} alt="Anterior" />
                    </button>

                    <button className={['next', showOnMobileClassName].join(' ')} onClick={onPrev}>
                        <img src={chevronIcon} alt="Próximo" />
                    </button>
                </div>
            )
        },
    };
}
